let types = {};

async function fetchTypes() {
    try {
        const response = await fetch('https://api.shop.actualoptic.kz/api/diagnostic-types');
        if (!response.ok) {
            throw new Error(`Ошибка загрузки: ${response.statusText}`);
        }
        types = await response.json();
    } catch (error) {
        console.error("Ошибка при загрузке типов диагностики:", error);
        types = {};
    }
}

fetchTypes();

function getDiagnosticTypes() {
    return types;
}

function getDiagnosticMinuteByKey(key) {
    return getDiagnosticTypes()[key]?.minutes || null;
}

function getDiagnosticTypesArray() {
    return Object.keys(getDiagnosticTypes());
}

function getDiagnosticTypeTitle(key) {
    return getDiagnosticTypes()[key]?.title || null;
}

export {
    getDiagnosticTypes,
    getDiagnosticTypesArray,
    getDiagnosticTypeTitle,
    getDiagnosticMinuteByKey
};
